import React from 'react';

const SvgSwitcherHot = props => (
	<svg width={79} height={35} {...props}>
		<g fill="none" fillRule="evenodd">
			<path
				stroke="#D5D2D5"
				d="M39.5 34.5V.5h-22C8.111.5.5 8.111.5 17.5s7.611 17 17 17h22z"
			/>
			<path
				d="M23.035 8.439V28.25m2.914-17.576l-2.914 1.78-2.913-1.78m0 15.503l2.912-1.78 2.915 1.78m5.634-12.837L14.488 23.35m16.639-6.368l-3.009-1.614.063-3.414m-13.377 7.835l3.009 1.615-.064 3.413M14.44 13.422l17.12 9.968M17.837 12.028l.073 3.414-3.006 1.622m13.398 7.801l-.072-3.413 3.005-1.623"
				stroke="#35A8E0"
				strokeLinecap="round"
				strokeWidth={1.026}
			/>
			<path
				fill="#F05146"
				d="M39 0h22.5C71.165 0 79 7.835 79 17.5S71.165 35 61.5 35H39V0z"
			/>
			<g stroke="#FFF" strokeLinecap="round">
				<path
					strokeWidth={0.775}
					d="M60.707 17.97a4.737 4.737 0 1 1-9.475 0 4.737 4.737 0 0 1 9.475 0z"
				/>
				<path
					strokeWidth={0.944}
					d="M55.97 27.444v-2.506m0-13.935V8.497m4.737 17.73l-1.276-2.208m-6.969-12.07L51.234 9.82M61.98 21.493h.002l2.193 1.268m-14.262-8.235l-2.147-1.24m17.678 4.738h-2.508m-13.932-.001h-2.507m17.678-4.737l-2.147 1.24M47.766 22.76l2.192-1.267h.001M60.707 9.82l-1.229 2.128m-6.969 12.071l-1.275 2.208"
				/>
			</g>
		</g>
	</svg>
);

export default SvgSwitcherHot;
